/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: I18nFixture
// source: i18n/*/*.json

import type { LibraryType } from "@pdfking/i18n"
import type { EnumUnion } from "@pdfking/structs"
import { LibraryFromJson } from "@pdfking/i18n"

const raw: LibraryType<Readonly<{
  forms: EnumUnion<{
    TYPE_ERROR: undefined
    REQUIRED_ERROR: undefined
    CHOICE_ERROR: { choices: unknown }
    CONTAINER_ERROR: { count: unknown }
    MIN_ERROR: { min: unknown }
    MAX_ERROR: { max: unknown }
    MIN_LENGTH_ERROR: { min: unknown }
    MAX_LENGTH_ERROR: { max: unknown }
    QUANTITY_PARSE_ERROR: { input: unknown }
    QUANTITY_UNIT_ERROR: { unit: unknown; example: unknown }
    QUANTITY_LENGTH_ERROR: { expected: unknown; got: unknown }
    QUANTITY_EXP_ERROR: { value: unknown }
    QUANTITY_DIVIDE_ZERO_ERROR: undefined
    SIZE_TOO_LARGE_FOR_MACHINE: { size: unknown; machine: unknown }
    SIGNATURE_TOO_LARGE_FOR_PAGES: { pages: unknown }
    BOOK_INTERIOR_MUST_BE_DUPLEX: undefined
    HORIZON_COVER_NO_FLAPS: undefined
    HORIZON_SINGLE_COVER_AT_START: undefined
    HORIZON_ONLY_QUARTINI: undefined
    HORIZON_NO_LOOSE_PAGES: undefined
  }>
}>, "en" | "fr" | "it"> = {
  forms: {
    en: () => import("../i18n/forms/en.json"),
    fr: () => import("../i18n/forms/fr.json"),
    it: () => import("../i18n/forms/it.json"),
  },
} as const

export const { forms } = LibraryFromJson(raw)
